import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { __privateAdd, __privateGet, __privateMethod, __privateSet } from "./chunk-PXG64RU4.js"; // src/mutation.ts

import { notifyManager } from "./notifyManager.js";
import { Removable } from "./removable.js";
import { createRetryer } from "./retryer.js";

var _observers, _mutationCache, _retryer, _Mutation_instances, dispatch_fn;

var Mutation = /*#__PURE__*/function (_Removable) {
  function Mutation(config) {
    var _this2;

    _classCallCheck(this, Mutation);

    _this2 = _callSuper(this, Mutation);

    __privateAdd(_this2, _Mutation_instances);

    __privateAdd(_this2, _observers);

    __privateAdd(_this2, _mutationCache);

    __privateAdd(_this2, _retryer);

    _this2.mutationId = config.mutationId;

    __privateSet(_this2, _mutationCache, config.mutationCache);

    __privateSet(_this2, _observers, []);

    _this2.state = config.state || getDefaultState();

    _this2.setOptions(config.options);

    _this2.scheduleGc();

    return _this2;
  }

  _inherits(Mutation, _Removable);

  return _createClass(Mutation, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
      this.updateGcTime(this.options.gcTime);
    }
  }, {
    key: "meta",
    get: function get() {
      return this.options.meta;
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      if (!__privateGet(this, _observers).includes(observer)) {
        __privateGet(this, _observers).push(observer);

        this.clearGcTimeout();

        __privateGet(this, _mutationCache).notify({
          type: "observerAdded",
          mutation: this,
          observer: observer
        });
      }
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      __privateSet(this, _observers, __privateGet(this, _observers).filter(function (x) {
        return x !== observer;
      }));

      this.scheduleGc();

      __privateGet(this, _mutationCache).notify({
        type: "observerRemoved",
        mutation: this,
        observer: observer
      });
    }
  }, {
    key: "optionalRemove",
    value: function optionalRemove() {
      if (!__privateGet(this, _observers).length) {
        if (this.state.status === "pending") {
          this.scheduleGc();
        } else {
          __privateGet(this, _mutationCache).remove(this);
        }
      }
    }
  }, {
    key: "continue",
    value: function _continue() {
      var _ref;

      var _a;

      return (_ref = (_a = __privateGet(this, _retryer)) == null ? void 0 : _a.continue()) !== null && _ref !== void 0 ? _ref : // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
      this.execute(this.state.variables);
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(variables) {
        var _this3 = this,
            _this$options$retry;

        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, onContinue, restored, isPaused, context, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              onContinue = function onContinue() {
                __privateMethod(_this3, _Mutation_instances, dispatch_fn).call(_this3, {
                  type: "continue"
                });
              };

              __privateSet(this, _retryer, createRetryer({
                fn: function fn() {
                  if (!_this3.options.mutationFn) {
                    return Promise.reject(new Error("No mutationFn found"));
                  }

                  return _this3.options.mutationFn(variables);
                },
                onFail: function onFail(failureCount, error) {
                  __privateMethod(_this3, _Mutation_instances, dispatch_fn).call(_this3, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                  });
                },
                onPause: function onPause() {
                  __privateMethod(_this3, _Mutation_instances, dispatch_fn).call(_this3, {
                    type: "pause"
                  });
                },
                onContinue: onContinue,
                retry: (_this$options$retry = this.options.retry) !== null && _this$options$retry !== void 0 ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode,
                canRun: function canRun() {
                  return __privateGet(_this3, _mutationCache).canRun(_this3);
                }
              }));

              restored = this.state.status === "pending";
              isPaused = !__privateGet(this, _retryer).canStart();
              _context.prev = 4;

              if (!restored) {
                _context.next = 9;
                break;
              }

              onContinue();
              _context.next = 16;
              break;

            case 9:
              __privateMethod(this, _Mutation_instances, dispatch_fn).call(this, {
                type: "pending",
                variables: variables,
                isPaused: isPaused
              });

              _context.next = 12;
              return (_b = (_a = __privateGet(this, _mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this);

            case 12:
              _context.next = 14;
              return (_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables);

            case 14:
              context = _context.sent;

              if (context !== this.state.context) {
                __privateMethod(this, _Mutation_instances, dispatch_fn).call(this, {
                  type: "pending",
                  context: context,
                  variables: variables,
                  isPaused: isPaused
                });
              }

            case 16:
              _context.next = 18;
              return __privateGet(this, _retryer).start();

            case 18:
              data = _context.sent;
              _context.next = 21;
              return (_f = (_e = __privateGet(this, _mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this);

            case 21:
              _context.next = 23;
              return (_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context);

            case 23:
              _context.next = 25;
              return (_j = (_i = __privateGet(this, _mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this);

            case 25:
              _context.next = 27;
              return (_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context);

            case 27:
              __privateMethod(this, _Mutation_instances, dispatch_fn).call(this, {
                type: "success",
                data: data
              });

              return _context.abrupt("return", data);

            case 31:
              _context.prev = 31;
              _context.t0 = _context["catch"](4);
              _context.prev = 33;
              _context.next = 36;
              return (_n = (_m = __privateGet(this, _mutationCache).config).onError) == null ? void 0 : _n.call(_m, _context.t0, variables, this.state.context, this);

            case 36:
              _context.next = 38;
              return (_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, _context.t0, variables, this.state.context);

            case 38:
              _context.next = 40;
              return (_r = (_q = __privateGet(this, _mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, _context.t0, this.state.variables, this.state.context, this);

            case 40:
              _context.next = 42;
              return (_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, _context.t0, variables, this.state.context);

            case 42:
              throw _context.t0;

            case 43:
              _context.prev = 43;

              __privateMethod(this, _Mutation_instances, dispatch_fn).call(this, {
                type: "error",
                error: _context.t0
              });

              return _context.finish(43);

            case 46:
              _context.prev = 46;

              __privateGet(this, _mutationCache).runNext(this);

              return _context.finish(46);

            case 49:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 31, 46, 49], [33,, 43, 46]]);
      }));

      function execute(_x) {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }]);
}(Removable);

_observers = new WeakMap();
_mutationCache = new WeakMap();
_retryer = new WeakMap();
_Mutation_instances = new WeakSet();

dispatch_fn = function dispatch_fn(action) {
  var _this4 = this;

  var reducer = function reducer(state) {
    switch (action.type) {
      case "failed":
        return _objectSpread(_objectSpread({}, state), {}, {
          failureCount: action.failureCount,
          failureReason: action.error
        });

      case "pause":
        return _objectSpread(_objectSpread({}, state), {}, {
          isPaused: true
        });

      case "continue":
        return _objectSpread(_objectSpread({}, state), {}, {
          isPaused: false
        });

      case "pending":
        return _objectSpread(_objectSpread({}, state), {}, {
          context: action.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: action.isPaused,
          status: "pending",
          variables: action.variables,
          submittedAt: Date.now()
        });

      case "success":
        return _objectSpread(_objectSpread({}, state), {}, {
          data: action.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: false
        });

      case "error":
        return _objectSpread(_objectSpread({}, state), {}, {
          data: void 0,
          error: action.error,
          failureCount: state.failureCount + 1,
          failureReason: action.error,
          isPaused: false,
          status: "error"
        });
    }
  };

  this.state = reducer(this.state);
  notifyManager.batch(function () {
    __privateGet(_this4, _observers).forEach(function (observer) {
      observer.onMutationUpdate(action);
    });

    __privateGet(_this4, _mutationCache).notify({
      mutation: _this4,
      type: "updated",
      action: action
    });
  });
};

function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}

export { Mutation, getDefaultState };